export const NavigationRoutes = {
  dashboard: '/Dashboard',
  orderLookUpCustomerId: '/OrderLookup',
  orderItem: '/OrderItem',
  orderManagement: '/OrderManagement',
  orderManagementById: '/OrderManagementById',
  popupForm: '/PopupForm',
  materialList: '/MaterialList',
  materialForm: '/MaterialForm',
  staffData: '/StaffData',
  colors: '/Colors',
  carrierList: '/CarrierList',
  commodityDensityMapping: '/CommodityDensityMapping',
  plyList: '/PlyList',
  packagingStatus: '/PackagingStatusList',
  roles: '/Roles',
  productionProcess: '/ProductionProcess',
  checkListTemplate: '/CheckListTemplate',
  productionStation: '/ProductionStation',
  customerMaster: '/Customer',
  modifyPartAssembly: '/ModifyPartAssembly',
  parts: '/Parts',
  editCustomer: '/EditCustomer',
  customerContact: '/CustomerContact',
  partAssembly: '/PartAssembly',
  orderListPage: '/OrderListPage',
  productionScreen: '/ProductionScreen',
  assembleParts: '/AssembleParts',
  labelList: '/LabelList',
  labelDetails: '/LabelDetails',
  packagingScreen: '/packagingScreen',
  shippingScreen: '/shippingScreen',
  packagingItem: '/PackagingItem',
  shipmentItem: '/ShipmentItem',
  login: '/login',
  tvDisplay: '/tv-display',
  editRolePermission: '/editRolePermission',
  changePassword: '/changePassword',
  permission: '/Permissions',
  productionSchedule: '/ProductionSchedule',
  attachments: '/Attachments',
  engineering: '/Engineering',
  crm: '/Crm',
  lead: '/Leads',
  leadSource: '/LeadSource',
  opportunity: '/Opportunity',
  activity: '/Activity',
  admin: '/Admin',
  hardware: '/Hardware',
  brush: '/Brush',
  brushes: '/Brushes',
  brushType: '/BrushType',
  categorys: '/Categorys',
  type: '/type',
  product: '/product',
  management: '/Management',
  holiday: '/Holiday',
  modifyOpportunity: '/ModifyOpportunity',
  costMethod: '/CostMethod',
  componetMaster: '/ComponetMaster',
  partComponent: '/PartComponent',
  columnSelection: '/columnSelection',
  partDetails: '/PartDetails',
  newPart: '/NewPart',
  report: '/Report',
  shippedOrders: '/ShippedOrders',
  openOrders: '/OpenOrders',
  userActivity: '/UserActivity',
  estimationDetails: '/EstimationDetails',
  estimationList: '/Estimations',
  managersActivityReport: '/managersActivityReport',
  currentDayManagersActivityReport: '/currentDayManagersActivityReport',
  fabricationReport: '/fabricationReport',
  bunCalcQty: '/bunCalcQty',
  crmManufacture: '/Manufacture',
  makeUpReport: '/MakeupReport',
  weightEntry: '/WeightEntry',
  widgetSetup: '/widgetSetup',
  shopItemDetail: '/ShopItemDetail',
  shopItem: '/ShopItem',
  category: '/Category',
  trackingReports: '/trackingReports',
  webOrders: '/webOrders',
  carouselImages: '/carouselImages',
  webDetails: '/webDetails',
  customerOrderReport: '/customerOrderReport',
  utilizationReport: '/utilizationReport',
  productionOpenOrders: '/productionOpenOrders',
  companyTrackingReports: '/companyTrackingReports',
  timeClock: '/timeClock',
  editTimeClock: '/editTimeClock',
  staffOnSite: '/staffOnSite',
  timeClockReport: '/timeClockReport',
  customerMap: '/customerMap',
  timeCard: '/timeCard',
  staffOffSite: '/staffOffSite',
  width: '/width',
  vacationRequest: '/vacationRequest',
  vacationApproval: '/vacationApproval',
  blackoutDays: '/blackoutDays',
  orderRegions: '/orderRegions',
  customerRegions: '/customerRegions',
  partCategory: '/partCategory',
  daysToShipReport: '/daysToShipReport',
  perDayToShipReport: '/perDayToShipReport',
  kitsList: '/kitsList',
  modifyKit: '/modifyKit',
  assignedProductionTo: '/assignedProductionTo',
  partApprovalWorkflow: '/partApprovalWorkflow',
  timeClockNotices: '/timeClockNotices',
  partRequest: '/partRequest',
  partRequestDetails: '/partRequestDetails',
  partCreation: '/partCreation',
  draftPartList: '/draftPartList',
  draftPartDetails: '/draftPartDetails',
  partApproval: '/partApproval',
  maps: '/maps',
  partApprovalRoutes: '/partApprovalRoutes',
  thompsonsDieBoard: '/thompsonsDieBoard',
  cut: '/cut',
  header: '/header',
  size: '/size',
  sketch: '/sketch',
  helpText: '/helpText',
  notificationList: '/notificationList',
  userNotifications: '/userNotifications',
  notificationRole: '/notificationRole',
  webUser: '/webUser',
  sites: '/sites',
  siteDetails: '/siteDetails',
  rawParts: '/rawParts',
  hiLo: '/hiLo',
  workingDay: '/WorkingDay',
  warehouse: '/Warehouse',
  inventory: '/Inventory',
  pickRawGoods: '/PickRawGoods',
  placeRawGoods: '/PlaceRawGoods',
  inventoryReport: '/InventoryReport',
  rma: '/RMA',
  rmaDetail: '/rmaDetail',
  rmaList: '/rmaList',
  skiving: '/Skiving',
  rackBin: '/rackBin',
  event: '/event',
  qtyYield: '/qtyYield',
  widthSettings: '/widthSettings',
  lengthSettings: '/lengthSettings',
  bandsaw: '/bandsaw',
  testimonial: '/testimonial',
  howToVideo: '/howToVideo',
  partOpenOrderReport: '/partOpenOrderReport',
  checkListReport: '/checkListReport',
  scheduledItemsWithoutStation: '/scheduledItemsWithoutStation',
  nlReportGenerator: '/NLReportGenerator',
  settings: '/settings',
  staffLeaveReset: '/staffLeaveReset',
  callRail: '/callRail',
  callRailBadCallReason: '/callRailBadCallReason',
  editStaff: '/editStaff',
  staffPoints: '/staffPoints',
  monthlyWinners:'/monthlyWinners',
  walkupLogin: '/walkup-login',
  walkupDashboard: '/w/Dashboard',
  walkupTimeCard: '/w/time-card',
  walkupVacationRequest: '/w/vacation-request',
  walkupStaffPoints: '/w/staff-points',
  walkupChangePassword: '/w/change-password',
  walkupNotificationList: '/w/notification-list',
};
export const alphabets = /^[A-Za-z\s]+$/;

export const numeric = /^[0-9]*$/;

export const bothNumericAlphabets = /^[a-z0-9\s]+$/i;

export const processApiResponse = (apiResponse: any): any => {
  const response = apiResponse;
  switch (response?.status) {
    case 200:
      return Promise.resolve(response?.data);
    case 204:
      return Promise.resolve(true);
    case 'success':
      return Promise.resolve(response?.data);
    case 'accepted':
      return Promise.resolve(response?.data);
    case 'error':
      return Promise.reject(response?.error);
    default:
      return Promise.reject(apiResponse);
  }
};

export const patchApiResponse = (apiResponse: any): any => {
  const response = apiResponse;
  switch (response?.status) {
    case 200:
      return Promise.resolve(true);
    case 204:
      return Promise.resolve(true);
    case 'success':
      return Promise.resolve(response?.data);
    case 'accepted':
      return Promise.resolve(response?.data);
    case 404:
      return Promise.reject(false);
    case 500:
      return Promise.reject(false);
    case 'error':
      return Promise.reject(response?.error);
    default:
      return Promise.reject(apiResponse);
  }
};

export const partListFields =
  'PartNumber,partId,labelDescription,description,webDescription,width,length,angleCut,attachmentId,plyId,cutHeaderSize,color,materialId,msrp,cost,inactive,minQty,maxQty,reorderLevel,rawGoodBarcodeNum,gallopPartNumber,bin,drawingLink,partNoteToProductionTeamSpecific,colorId,ply_Id,ProductionProcessId,newPart';

export const PartAssemblyListFields =
  'PartAssemblyId,AssemblyName,Note,Link,LinkToLabel,FinishedGoodBarcodeNum,OrderEntryMultiplyby2,assemblyNumber';

export const customerFilteredList =
  'CustomerId,CustomerName,City,State,Country,PaymentTerms,Inactive,Address1';

export const orderItemFilteredList =
  'orderItemId,orderId,qty,width,length,angleCut,attachmentId,additionToLength,addLength2PlyWelting,colorCodeLabels,cutHeaderSize,color,angleEquation,plyEquation,plyId,materialId,foamPartsSheet,productionProcessId,productionStationId,coreGuardSleeve,packagingComplete,partId,shipDate,packagingCompleteDate,qtyShipped,partAssemblyId,assignedtoLabDetRecId,colorId,ply_Id,part.labelDescription,part.description,part.partNumber,isSubPart,isAllSubPartCompleted,parentOrderItemId,sortOrder,partKitId,PartKit.kitNumber,PartKit.kitName,PartAssembly.AssemblyName,PartAssembly.AssemblyNumber';

export const SweetAlertConst = {
  added: 'Added',
  addedSuccessfully: 'Added Successfully',
  update: 'Update!',
  updateSuccessfully: 'Updated Successfully',
  delete: 'Deleted!',
  deletedSuccessfully: 'Deleted Successfully',
  error: 'Error',
  somethingWentWrong: 'Something Went Wrong',
  areYouSure: 'Are You Sure?',
  confirmSubTitle: `You won't be able to revert this!`,
  cloned: 'Cloned',
  clonedSuccessfully: 'Cloned Successfully',
  noInternetTitle: 'No Internet Connection',
  noInternetSubTitle:
    'Please check your internet connection and try again.',
  requestTimedOutTitle: 'Request Timed Out',
  requestTimedOutSubTitle:
    'The server took too long to respond. Please check your connection and try again.',
};
